import { useSyncStore } from '@/stores/syncStore';
import { syncNow } from '@/lib/sync';
import { StatusChip } from '@/components/ui/StatusChip';

/** Tells the supervisor the truth about their data at a glance: online or
 *  not, how many entries are still waiting, and when the last successful
 *  sync happened. A cached dashboard must never look live. */
export function SyncIndicator() {
  const { online, syncing, pending, lastSyncAt, issues, setIssuesOpen } = useSyncStore();

  const tone = !online ? 'amber' : issues.length ? 'red' : pending ? 'blue' : 'green';
  const label = !online
    ? `Offline${pending ? ` · ${pending} queued` : ''}`
    : syncing
      ? 'Syncing…'
      : issues.length
        ? `${issues.length} sync issue${issues.length > 1 ? 's' : ''}`
        : pending
          ? `${pending} queued`
          : 'Synced';

  const stamp = lastSyncAt
    ? new Date(lastSyncAt).toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' })
    : null;

  return (
    <button
      className="btn btn--ghost sync-btn"
      style={{ minHeight: 32, padding: '0 var(--sp-2)' }}
      // With refused changes waiting, the chip opens them — on any screen.
      // Otherwise it syncs now, as before.
      onClick={() => (issues.length ? setIssuesOpen(true) : void syncNow())}
      title={issues.length
        ? 'Changes the server refused — click to see why'
        : stamp ? `Last synced ${stamp}` : 'Not yet synced'}
    >
      <StatusChip tone={tone}>{label}</StatusChip>
      {stamp && <span className="small muted sync-btn__time">{stamp}</span>}
    </button>
  );
}
